'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarRadioButtonStyles_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarRadioButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const useBaseStyles = /*#__PURE__*/ (0, _react.__styles)({
    selected: {
        De3pzq: "fq5gl1p",
        sj55zd: "f1eryozh"
    },
    iconSelected: {
        sj55zd: "f1qj7y59"
    }
}, {
    d: [
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1eryozh{color:var(--colorNeutralForeground2Selected);}",
        ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}"
    ]
});
const useToolbarRadioButtonStyles_unstable = (state)=>{
    'use no memo';
    const toggleButtonStyles = useBaseStyles();
    state.root.className = (0, _react.mergeClasses)(state.checked && toggleButtonStyles.selected, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(state.checked && toggleButtonStyles.iconSelected, state.icon.className);
    }
    (0, _reactbutton.useToggleButtonStyles_unstable)(state);
    return state;
};
